export default __webpack_public_path__ + "static/media/sf4.c88da6d0.jpeg";